export const actionTypes = {
  FETCH_DYNAMIC_CONTENT_PRICING: 'fetchDynamicContent',
  FETCH_DYNAMIC_TRIGGER_PRICING: 'fetchDynamicContentTrigger',
  FETCH_PAYMENT_INFO: 'fetchPaymentInfo',
  SET_VIEW_COMMUNITY_META: 'setViewCommunityMeta',
}

export const mutationTypes = {
  SET_DYNAMIC_CONTENT_PRICING: 'SET_DYNAMIC_CONTENT_PRICING',
  SET_DYNAMIC_TRIGGER_PRICING: 'SET_DYNAMIC_TRIGGER_PRICING',
  SET_PAYMENT_INFO: 'setPaymentInfo',
  SET_YEARLY: 'SET_YEARLY',
  SET_LOADING_PRICING_PAGE: 'SET_LOADING_PRICING_PAGE'
}
